module.exports = __webpack_public_path__ + "img/custmor.a889eb19.png";